import { createFileRoute } from '@tanstack/react-router'
import { DraftSuratPanel } from '../../../../components/draft-surat/DraftSuratPanel'

export const Route = createFileRoute('/desa/$slug/dashboard/draft-surat')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <DraftSuratPanel desaId={desaId} />
  },
})
